import { gql } from '@apollo/client'

export const FRAGMENT_TIMECODE_FULL = gql`
  fragment FragmentTimecodeFull on Timecode {
    id
    title
    time
  }
`
